import { render, staticRenderFns } from "./biometry-auth.vue?vue&type=template&id=3068cc19&"
import script from "./biometry-auth.vue?vue&type=script&lang=js&"
export * from "./biometry-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports